export function getMapCoordinates(coordinates?: string | null) {
  const [lat, lng] =
    coordinates
      ?.split(',')
      .map(Number)
      .filter((number) => !Number.isNaN(number)) ?? []

  return lat && lng ? { lat, lng } : undefined
}
